import { render, staticRenderFns } from "./area-breakdown.vue?vue&type=template&id=5ca6a558&scoped=true&"
import script from "./area-breakdown.vue?vue&type=script&lang=ts&"
export * from "./area-breakdown.vue?vue&type=script&lang=ts&"
import style0 from "./area-breakdown.vue?vue&type=style&index=0&id=5ca6a558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca6a558",
  null
  
)

export default component.exports